import React from 'react';
import { CheckCircle } from 'lucide-react';
import { aboutContent, companyInfo, siteAssets } from '../data/mock';

const AboutSection = () => {
  const highlights = [
    'Over 20 Years of Experience',
    'Residential & Commercial Services',
    'Licensed & Insured',
    'Quality Workmanship Guaranteed',
    'Serving Georgia & Florida',
    'Free Estimates Available',
  ];

  return (
    <section id="about" className="section-padding bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={siteAssets.aboutImage}
                alt="Professional landscaping team at work"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B3A3A]/60 to-transparent" />
            </div>
            
            {/* Experience Badge */}
            <div className="absolute -bottom-6 -right-6 lg:bottom-8 lg:-right-8 bg-[#D3FF62] rounded-2xl p-6 shadow-xl">
              <div className="text-center">
                <span className="text-4xl lg:text-5xl font-bold text-[#1B3A3A]">
                  {companyInfo.yearsExperience}+
                </span>
                <p className="text-[#1B3A3A] font-semibold text-sm">
                  Years Experience
                </p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="text-[#2D5A4A] font-semibold text-sm uppercase tracking-wider">
              About Us
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B3A3A] mt-3 mb-6">
              {aboutContent.title.replace('About ', '')}
            </h2>
            
            <div className="prose prose-lg text-[#6B7B7B] mb-8">
              {aboutContent.description.split('\n\n').slice(0, 2).map((paragraph, index) => (
                <p key={index} className="mb-4">
                  {paragraph}
                </p>
              ))}
            </div>

            {/* Highlights Grid */}
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-3 bg-[#F5F9E8] rounded-xl"
                >
                  <CheckCircle className="text-[#2D5A4A] flex-shrink-0" size={20} />
                  <span className="text-[#1B3A3A] font-medium text-sm">{item}</span>
                </div>
              ))}
            </div>

            <a href="#contact" className="btn-primary">
              Get Started Today
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
